export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageSeq: string;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    slug: 'illustration',
    name: '插画作品',
    description: '汇聚顶尖画师原创插画，涵盖日系、古风、赛博朋克等多种风格，每一幅都是视觉盛宴。',
    icon: 'ri-paint-brush-line',
    articleCount: 1286,
    imageSeq: 'cat-illust-01',
    imageQuery: 'Beautiful%20anime%20illustration%20artwork%20with%20vibrant%20colors%20and%20detailed%20character%20design%2C%20soft%20dreamy%20background%2C%20Japanese%20manga%20style%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20pastel%20color%20palette%20with%20warm%20accents%2C%20professional%20illustration%20style%20with%20subtle%20textures',
  },
  {
    slug: 'comic',
    name: '漫画连载',
    description: '原创漫画作品持续更新，热血、恋爱、悬疑、日常，总有一部是你的心头好。',
    icon: 'ri-book-open-line',
    articleCount: 943,
    imageSeq: 'cat-comic-01',
    imageQuery: 'Anime%20manga%20comic%20page%20layout%20with%20dynamic%20panels%20and%20expressive%20characters%2C%20black%20and%20white%20line%20art%20with%20screen%20tones%2C%20Japanese%20comic%20aesthetic%2C%20action%20scene%20composition%2C%20detailed%20background%20art%2C%20professional%20manga%20style',
  },
  {
    slug: 'doujin',
    name: '同人创作',
    description: '基于热门 IP 的二次创作作品，粉丝用爱发电，创造无限可能的平行世界。',
    icon: 'ri-heart-pulse-line',
    articleCount: 2156,
    imageSeq: 'cat-doujin-01',
    imageQuery: 'Doujin%20fan%20art%20collection%20featuring%20various%20anime%20characters%20in%20creative%20scenarios%2C%20colorful%20and%20playful%20illustration%20style%2C%20warm%20and%20inviting%20atmosphere%2C%20diverse%20art%20styles%20showcasing%20fan%20creativity%2C%20soft%20lighting%2C%20whimsical%20composition',
  },
  {
    slug: 'cosplay',
    name: 'Cosplay',
    description: '还原度爆表的 Cos 作品展示，从服装道具到妆容造型，每一处细节都用心呈现。',
    icon: 'ri-user-star-line',
    articleCount: 867,
    imageSeq: 'cat-cosplay-01',
    imageQuery: 'Professional%20cosplay%20photography%20with%20elaborate%20anime%20character%20costume%20and%20detailed%20props%2C%20studio%20lighting%20with%20soft%20backdrop%2C%20creative%20posing%2C%20high%20quality%20costume%20design%2C%20dramatic%20yet%20elegant%20atmosphere%2C%20clean%20professional%20photography',
  },
  {
    slug: 'voice',
    name: '声优配音',
    description: '二次元声优配音作品集，用声音演绎角色灵魂，感受声线的无限魅力。',
    icon: 'ri-mic-line',
    articleCount: 534,
    imageSeq: 'cat-voice-01',
    imageQuery: 'Voice%20acting%20recording%20studio%20with%20professional%20microphone%20and%20anime%20character%20illustrations%20on%20display%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%2C%20sound%20proofing%20panels%2C%20cozy%20and%20artistic%20atmosphere%2C%20soft%20focus%20background%20with%20musical%20elements',
  },
  {
    slug: 'animation',
    name: '动画短片',
    description: '独立动画人原创短片作品，用帧与帧之间的魔法讲述打动人心的故事。',
    icon: 'ri-film-line',
    articleCount: 412,
    imageSeq: 'cat-anim-01',
    imageQuery: 'Anime%20animation%20production%20workspace%20with%20storyboard%20sketches%20and%20color%20palettes%2C%20creative%20digital%20drawing%20tablet%2C%20warm%20studio%20lighting%2C%20artistic%20atmosphere%20with%20character%20design%20sheets%2C%20clean%20and%20organized%20creative%20environment',
  },
];

export const categoryHeroImages: Record<string, string> = {
  illustration: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20gallery%20wall%20with%20various%20art%20styles%2C%20colorful%20and%20vibrant%20artwork%20display%2C%20Japanese%20manga%20and%20anime%20inspired%20paintings%2C%20warm%20gallery%20lighting%2C%20artistic%20atmosphere%2C%20clean%20elegant%20composition&width=1600&height=600&seq=cat-hero-illust&orientation=landscape',
  comic: 'https://readdy.ai/api/search-image?query=Manga%20comic%20library%20shelves%20filled%20with%20colorful%20Japanese%20comics%2C%20reading%20area%20with%20warm%20lighting%2C%20cozy%20and%20inviting%20atmosphere%2C%20organized%20bookshelves%2C%20artistic%20interior%20design%2C%20soft%20natural%20light%20from%20windows&width=1600&height=600&seq=cat-hero-comic&orientation=landscape',
  doujin: 'https://readdy.ai/api/search-image?query=Creative%20doujin%20art%20market%20with%20various%20fan%20art%20books%20and%20prints%20displayed%20on%20tables%2C%20colorful%20and%20diverse%20artwork%2C%20bustling%20yet%20organized%20atmosphere%2C%20warm%20convention%20lighting%2C%20creative%20community%20vibe&width=1600&height=600&seq=cat-hero-doujin&orientation=landscape',
  cosplay: 'https://readdy.ai/api/search-image?query=Elegant%20cosplay%20photography%20studio%20setup%20with%20professional%20lighting%20equipment%2C%20costume%20racks%20with%20detailed%20anime%20outfits%2C%20props%20and%20accessories%20displayed%2C%20creative%20workspace%2C%20warm%20and%20inviting%20atmosphere&width=1600&height=600&seq=cat-hero-cosplay&orientation=landscape',
  voice: 'https://readdy.ai/api/search-image?query=Professional%20voice%20recording%20studio%20with%20high%20quality%20microphone%2C%20sound%20dampening%20panels%2C%20mixing%20console%2C%20warm%20ambient%20lighting%2C%20anime%20character%20posters%20on%20walls%2C%20creative%20and%20professional%20atmosphere&width=1600&height=600&seq=cat-hero-voice&orientation=landscape',
  animation: 'https://readdy.ai/api/search-image?query=Animation%20studio%20workspace%20with%20light%20tables%20and%20drawing%20tablets%2C%20storyboards%20on%20walls%2C%20color%20scripts%20and%20character%20designs%2C%20creative%20and%20organized%20environment%2C%20warm%20studio%20lighting%2C%20professional%20animation%20production&width=1600&height=600&seq=cat-hero-anim&orientation=landscape',
};